import { css } from '@emotion/react';
import { DesignToken } from '@livechat/design-system-react-components';

export const button = css`
  color: var(${DesignToken.ColorWhite}) !important;
`;
